import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchBootstrap, getCsioConfig } from '@/shared/api/csio';
import { emptySiteContent, mapBootstrapContent, } from './mapContent';
export var useCsioBootstrap = function () {
    var _a;
    var config = useMemo(function () { return getCsioConfig(); }, []);
    var query = useQuery({
        queryKey: ['csio-bootstrap', config.mode, config.slug, config.domain, config.apiBase],
        queryFn: function () { return fetchBootstrap(config); },
        staleTime: 60000,
        retry: 1,
    });
    var bootstrap = (_a = query.data) !== null && _a !== void 0 ? _a : null;
    var content = bootstrap ? mapBootstrapContent(bootstrap) : emptySiteContent();
    var leadForms = Array.isArray(bootstrap === null || bootstrap === void 0 ? void 0 : bootstrap.leadForms) ? bootstrap.leadForms : [];
    return {
        config: config,
        bootstrap: bootstrap,
        content: content,
        leadForms: leadForms,
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error instanceof Error ? query.error : null,
    };
};
